<template>
  <div class="maxBox" ref="main" @scroll="handleScroll">
    <div class="topNav">
      <div class="logipt">
        <div class="logoBox">
          <div class="logo_title" @click="GoToChangeTab(0)" style="cursor: pointer;">
          	<h1>{{corpTitle}}</h1>
          </div>
          <div
            class="inputs"
            style="width: 485px !important; background: #f7f7f7ff"
          >
            <img src="../../assets/image/search.png" alt="" />
            <input
              ref="inputRef"
              class="ipus"
              style="
                color: #999999;
                outline: none;
                background: rgb(247, 247, 247);
                border: none;
                width: 360px;
                height: 34px;
                font-size: 16px;
              "
              confirm-type="search"
              placeholder-class="text"
              placeholder="书名、作者、关键字"
              @focus="input_focusIpt"
              v-on:keyup.enter="input_search(input_content)"
              v-model="input_content"
            />
            <div
              class="btnBox"
              style="
                width: 88px;
                height: 34px;
                line-height: 34px;
                font-size: 16px;
                background: #e6564eff;
                color: white;
                border-radius: 19px;
                cursor: pointer;
              "
              @click="input_search()"
            >
              搜索
            </div>
          </div>
          <div class="showContent" v-if="isInputing2">
            <div class="titleBg">
              <div class="title">热门搜索</div>
              <div class="clear"></div>
            </div>
            <div
              class="item"
              v-for="(item, index) in hotKeywords"
              :key="index"
              @click="input_search(item.title)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
		<div style="display: flex;">
			<div class="logo_title">
				<h3 class="h3" @click="handelChangeTab(9)">
					我的书架
				</h3>
			</div>
      <div class="logo_title">
				<h3 class="h3" @click="handelChangeTab(10)">
					学习报告
				</h3>
        </div>
		</div>
      </div>
      <!-- tab栏 -->
      <div
        class="tablistBg"
        v-if="isShowNav"
        style="height: 70px; box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1)"
      ></div>
      <div
        class="tablistBg"
        :class="isShowNav ? 'topNavShow' : ''"
        style="margin-top: 0px"
      >
        <div class="tablist">
          <div
            class="tab-as"
            v-for="(item, index) in sortedCategoryList"
            :key="index"
            :class="{ tabActive: item.product_type == $route.meta.pos }"
            @click="handelChangeTab(item.product_type)"
            style="color: #333333"
          >
            {{ item.title }}
            <span
              v-if="item.product_type == 11"
              :class="item.product_type == num ? 'tabActive2' : 'unTabActive2'"
              style="color: #47cd96;padding-left:5px"
              >LIVE</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 当导航栏吸顶时添加占位元素，防止内容跳跃 -->
    <div v-if="isShowNav" class="nav-placeholder"></div>
    
    <!-- 二级路由出口 -->
    <div class="router-view-container">
        <router-view :parent-scroll-ref="parentScrollRef"></router-view>
    </div>
    <div class="footer">
    Copyright© 2025 机工新阅读
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import api from '@/api/index.js';
import ApiUrl from "../../js/apiUrl.js";

export default {
  name: 'ReadIndex',
  data() {
    return {
      num: 0, // 默认选中首页
      isShowNav: false, // 添加导航显示状态
      tabList:[],
      productTypeData: {},
      busy: false,
      input_content: "",
      hotKeywords: [],
      isInputing2: false, // 修复：不再引用props
      backTopRight: 200,
      isShowScrollBtn2: false,
      isGoIndex:false,
      corpTitle:'',
      isNavigating: false, // 添加导航状态，防止重复点击
      scrollTimer: null, // 添加滚动节流定时器
      parentScrollRef: 'main'  // 父容器的ref名称
    };
  },
  computed: {
    sortedCategoryList() {
      return this.tabList.slice().sort((a, b) => {
        return a.product_type - b.product_type;
      });
    }
  },
  mounted() {
    // 添加全局滚动监听器
    window.addEventListener('scroll', this.handleWindowScroll);
    // 同时监听容器滚动
    if (this.$refs.main) {
      this.$refs.main.addEventListener('scroll', this.handleScroll);
    }
    var screenWidth = document.body;
    screenWidth.style.overflow = "hidden";
    // 确保父容器有滚动条（关键样式）
    const container = this.$refs.main;
    if (container) {
      container.style.height = '800px';    // 固定父容器高度
      container.style.overflowY = 'auto';  // 纵向滚动
    }
    var option = {
      id: this.$route.query.id || "",
      token: this.$route.query.token || "",
    };
    this.CheckCorpAccount(option);
    this.setupList();
    this.hotKeywordsGet();
    this.setupCrop();
  },

  beforeDestroy() {
    // 移除滚动监听器以防止内存泄漏
    window.removeEventListener('scroll', this.handleWindowScroll);
    if (this.$refs.main) {
      this.$refs.main.removeEventListener('scroll', this.handleScroll);
    }
    
    // 清理定时器
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
  },
  methods: {
    GoToChangeTab(type) {
      if (type === 0) {
        // 导航到首页
        this.$router.push('/read/readIndex');
      }
    },
    handelChangeTab(type) {
        // 防止重复点击和导航中的点击
        if (this.isNavigating) {
          return;
        }
        // 根据不同tab类型进行路由导航
        let targetRoute = '';
        switch(type) {
          case 0: // 首页
            targetRoute = '/read/readIndex';
            break;
          case 1: // 电子书
            targetRoute = '/ebook';
            break;
          case 3: // 有声书
            targetRoute = '/aubook';
            break;
          case 4: // 课程
            targetRoute = '/course';
            break;
          case 5: // 分类
            targetRoute = '/read/ReadingClassify';
            break;
          case 6: // 主题书单
            targetRoute = '/read/themeBook';
            break;
          case 11: // 直播Live
            targetRoute = '/livebook';
            break;
          case 13: // 华章师资
            targetRoute = '/teachers';
            break;
          case 12: // 专题
            targetRoute = '/subject';
            break;
          case 9: // 我的书架
            targetRoute = '/read/myBookshelf';
            break;
          case 10: // 学习报告
            targetRoute = '/read/studyReport';
            break;
          default:
            console.log('未知的tab类型');
            return;
        }
        
        // 检查是否为当前路由，避免重复跳转
        if (this.$route.path === targetRoute) {
          return;
        }
        
        this.isNavigating = true;
        
        // 执行路由跳转
        this.$router.push(targetRoute).then(() => {
          this.isNavigating = false;
        }).catch(err => {
          // 处理路由跳转错误（比如重复导航）
          console.log('路由跳转错误:', err);
          this.isNavigating = false;
          if (err.name === 'NavigationDuplicated') {
            // 忽略重复导航错误
            return;
          }
        });
    },
    scrollToTop() {
      this.$emit("scrollToTop");
    },
    
    input_search(title) {
      if (title && title != "") this.input_content = title;
      this.$refs.inputRef.blur();
      this.isInputing2 = false;
      var url = "/SearchPage";
      var query = { inputStr: this.input_content };
      this.$router.push({
      	path: url,
      	query: query
      });
      /*
      let routeUrl = this.$router.resolve({
        path: url,
        query: query,
      });
      window.open(routeUrl.href, "_blank");
      */
      this.input_content = "";
    },
    input_focusIpt() {
      setTimeout(() => {
        this.isInputing2 = true;
        this.$refs.inputRef.focus();
        this.$forceUpdate();
      }, 200);
    },
    input_blurIpt() {
      this.isInputing2 = false;
      this.$refs.inputRef.blur();
      
    },
    handleWindowScroll() {
      // 使用节流优化性能
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      
      this.scrollTimer = setTimeout(() => {
        // 获取页面滚动位置
        const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // 设置吸顶临界值
        const stickyThreshold = 150; // 当滚动超过150px时开始吸顶
        const shouldShowNav = scrollY >= stickyThreshold;
        // 只有状态真正改变时才更新
        if (this.isShowNav !== shouldShowNav) {
          this.isShowNav = shouldShowNav;
          // console.log('导航栏吸顶状态:', this.isShowNav ? '已吸顶' : '未吸顶');
        }
      }, 10); // 10ms节流
    },
    handleScroll(e) {
      // 获取滚动位置
      let scrollY = e.target.scrollTop || window.pageYOffset || document.documentElement.scrollTop;
      console.log('当前滚动位置:', scrollY);
      // 设置吸顶临界值（当滚动超过导航栏高度时开始吸顶）
      const stickyThreshold = 90;
      if (scrollY >= stickyThreshold) {
        this.isShowNav = true;
      } else {
        this.isShowNav = false;
      }
      // 强制更新组件以确保样式变化
      this.$forceUpdate();
    },
    setupList() {
      var that = this;
      this.tabList = [];
       var token = this.$route.query.token;
      var param = { client_type: 2,token:token };
      this.Ajax(ApiUrl.shuyuan_navbar_get, param, (data) => {
        const hasHomePage = data.some(item => item.product_type === 0);
        if (!hasHomePage) {
          data.unshift({  // 使用 unshift 放在数组最前面，符合导航常规顺序
            img_url: "",
            product_type: 0,
            product_count: 0,
            title: "首页"
          });
        }
        data.forEach((item) => {
          if (item.product_type == 11) {
            item.title = "直播";
              }
        })
        if (data) {
          let length = data.length
          for (let i = 0; i < length; i++) {
              that.tabList.push(data[i]);
          }
          if (data.product_type == 11) {
            data.title = "直播";
          }
          
          that.tabList.push({
              img_url: "",
              product_type: 5,
              product_count: 0,
              title: "分类"
          },);
          const showCrop = localStorage.getItem("showCrop");
          if (showCrop === "Y") {
            that.tabList.push({
                img_url: "",
                product_type: 6,
                product_count: 0,
                title: "主题书单"
            });
          }
        }
          
      });
    },
    //热门搜索
    hotKeywordsGet() {
      var that = this;
      this.Ajax(ApiUrl.search_keywords_get, {}, function(data) {
        if (data && data.length > 0) {
          that.hotKeywords = data;
        }
      });
    },
    setupCrop(){
      var that = this;
      var token = localStorage.getItem("CorpUserInfo");
      var corp = localStorage.getItem("CorpInfo");
      // if (token && !corp) {
      if (token) {
        this.Ajax(ApiUrl.user_corp2_get, { token : token,client_type:2 }, (data) => {
            if (data) {
                localStorage.setItem("CorpInfo",data.title)
                that.corpTitle = data.title;
                var title = data.title;
                document.title = title;
                console.log(title)
            }
        });
      } 
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.maxBox {
  width: 100%;
  min-width: 1157px;
  cursor: default;
  position: relative; // 添加相对定位
  min-height: 100vh; // 确保容器至少占满视口高度
  
  .topNav {
    width: 100%;
    border: 1px solid #fff;
    background: #fff;
    position: relative;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    z-index: 10; // 确保导航栏在上层

    .hovers {
      width: 221px;
      height: 506px;

      z-index: 20;
      position: absolute;
      right: 290px;
      top: 90px;
      background: #fff;

      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
      display: none;
      .vipmoy {
        width: 180px;
        height: 20px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        margin-top: 14px;
        .viplo {
          width: 34px;
          height: 15px;
        }
        .spanv {
          width: 65px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #e6544c;
        }
      }
      .names {
        width: 171px;
        height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        margin-top: 8px;
      }
      .times {
        width: 123px;
        height: 20px;
        margin-left: 22px;
        margin-top: 9px;
        font-size: 14px;
        font-weight: 500;
        color: #999999;
      }
      .fenge {
        width: 179px;
        height: 1px;
        background: #eeeeee;
        margin: 0 auto;
        margin-top: 18px;
        margin-bottom: 18px;
      }
      .fosnam {
        width: 179px;
        height: 100px;
        margin: 0 auto;
        border-bottom: 1px solid #eeeeee;

        p {
          width: 76px;
          height: 25px;
          font-size: 18px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          letter-spacing: 1px;
          margin-top: 20px;
        }
      }
      .fonbot {
        width: 179px;
        height: 190px;
        margin: 0 auto;
        border-bottom: 1px solid #eeeeee;
        p {
          width: 76px;
          height: 25px;
          font-size: 18px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          letter-spacing: 1px;
          margin-top: 20px;
        }
      }
      .nect {
        width: 179px;
        height: 57px;
        margin: 0 auto;

        line-height: 57px;

        font-size: 18px;
        font-weight: 500;
        color: #333333;
      }
    }
    .logipt {
      width: 1157px;
      height: 60px;

      margin: 0 auto;
      margin-top: 27px;
      display: flex;
      justify-content: space-between;
      align-items: center;
	  
      .logoBox {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
		
		.logo_title {
			display: inline-block;
		
			h1 {
				font-size: 30px;
			}
		}
		
        .logo {
          width: 45px;
          height: 45px;
        }
        .inputs {
          width: 140px;
          height: 34px;
          background: #f7f7f7;
          border-radius: 25px;
          margin-left: 30px;
          text-align: center;
          font-size: 20px;
          line-height: 50px;
          display: flex;
          align-items: center;
          img {
            width: 17px;
            height: 17px;
            margin-left: 12px;
            margin-right: 12px;
          }
          span {
            font-size: 16px;
            font-weight: 500;
            color: #c9c9c9;
          }
        }
        .showContent {
          position: absolute;
          top: 50px;
          left: 320px;
          width: 452px;
          background: white;
          z-index: 99999;
          padding: 18px;
          .titleBg {
            display: flex;
            justify-content: space-between;
            margin-bottom: 3px;
            .title {
              width: 64px;
              height: 22px;
              font-size: 16px;
              font-weight: 500;
              color: #2b2b2b;
              line-height: 22px;
            }
            .clear {
              width: 32px;
              height: 22px;
              font-size: 16px;
              font-weight: 500;
              color: #e6564e;
              line-height: 22px;
            }
          }
          .item {
            height: 22px;
            font-size: 16px;
            font-weight: 500;
            color: #999999;
            line-height: 22px;
            margin-top: 10px;
            cursor: pointer;
          }
        }
      }
      .logins {
        width: 95px;
        height: 29px;
        font-size: 21px;
        font-weight: 500;
        color: #e6564e;
      }
      .users {
        width: 210px;
        height: 47px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        div {
          font-size: 21px;
          font-weight: 600;
          color: #e6564e;
          line-height: 25px;
          width: 130px;
          height: 25px;
          border-right: 3px solid #d8d8d8;
        }
      }
    }
    .tablistBg {
      width: 100%;
      background: white;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .topNavShow {
      position: fixed !important;
      z-index: 999 !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      background: white;
      margin-top: 0 !important;
      width: 100% !important;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
      animation: slideDown 0.3s ease-out;
    }
    .tablist {
      height: 70px;
      width: 1157px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;

      align-items: center;
      font-size: 21px;
      font-weight: 400;
      color: #bdbdbd;
      position: relative;
      margin-top: 0px !important;

      .tabActive {
        font-size: 24px;
        font-weight: 500;
        color: #e6564e !important;
        padding-bottom: 5px;
        text-align: center;

        display: flex;
        justify-content: center;
      }
      .tab-as {
        text-align: center;
        display: flex;
        justify-content: center;
        cursor: pointer;
      }
      .tab-as:hover:before {
        content: "";
        width: 40px;
        border-radius: 5px;
        height: 3px;
        position: absolute;
        text-align: center !important;
        background-color: #e45754;
        display: block;
        bottom: 0;
      }
      .tabActive2 {
        margin-left: 0;
      }
      .unTabActive2 {
        margin-left: -6px;
      }
      .tabActive::before {
        content: "";
        width: 26px;
        border-radius: 5px;
        height: 3px;
        position: absolute;
        text-align: center !important;
        background-color: #e45754;
        display: block;
        bottom: 0;
      }
      }
    }
    .tablist:hover {
      cursor: pointer;
    }
  }

/* 添加吸顶动画 */
@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 当导航栏吸顶时，为避免内容跳跃，添加占位高度 */
.nav-placeholder {
  height: 70px;
  width: 100%;
  background: transparent;
  display: block; // 确保占位元素正确显示
}

.router-view-container {
    width: 100%;
    min-width: 1157px;
    background: #f7f7f7; 
    margin: 0 auto;
    min-height: calc(100vh - 300px); // 调整最小高度
    position: relative; // 添加相对定位
    z-index: 1; // 确保正确的层级
    padding-bottom: 20px; // 添加底部内边距
}
// footer区域
.footer {
    position: relative; // 改为相对定位，不再固定在底部
    bottom: auto;
    width: 100%;
    height: 120px;
    background-color: #282828;
    text-align: center;
    line-height: 120px;
    color: #666;
    margin-top: 50px; // 增加上边距
    z-index: 1; // 确保显示层级
}
.logo_title {
  display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
        margin-right: 20px;
        .h3 {
          font-size: 18px;color: #2b2b2b;
          cursor: pointer;
        }
} 
</style>
